
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onUnmounted
} from "vue";
import NativeClient, { TitleInfo } from "@/client/native-client";
import store from "@/store";
import router from "@/router";
import {
  PANTRY_FOOD_TYPE,
  DETAIL_ITEM_TYPE,
  PLATE_DATE_SETTING,
  PLATE_SELECT_DATE_TYPE,
  PANTRY_RECIPE_TYPE,
  PANTRY_STRING,
  RequstPantryPlateDetail,
  PantryDetailInfo,
  DETAIL_ITEM_DATA,
  RegisterPantryInfo,
  UpdatePantryInfo,
  UpdatePantryPlateInfo,
  UpdatePantryFridgeInfo,
  DateValueInfo,
  PlateInfoData,
  NETWORK_TIMING,
  PLATE_DISPLAY_FORMAT,
  RequestRecommendRecipe,
  RecipeFoodItemInfo,
  PLATE_DELETE_FOOD_STATUS,
  DeletePantryInfo,
  DetetePantryItem,
  DetetePantryPlateItem,
  DetetePantryFridgeItem,
  RequestFavoriteFood,
  RequestUpdateFoodData,
  RequestUpdatePlateFoodData,
  RequestUpdateFridgeFoodData,
  RequstPantryPlateSettingWeight,
  ALL_TIME_CONNECT_MODE,
  RequestFoodRecommendation,
  PANTRY_STORAGE_TYPE,
  DEFALT_FOOD_ID,
  RequestShoppingFoods,
  RequestShoppingFood,
} from "@/types/pantry";
import {
  createRecipeToCommonRecipes
} from "@/utils/search-util";
import PantryDetailView from "@/components/pantry/PantryDetailView.vue";
import PantryDateValueDialog from "@/components/pantry/PantryDateValueDialog.vue";
import PantryValueDialog from "@/components/pantry/PantryValueDialog.vue";
import PantryStroageValueDialog from "@/components/pantry/PantryStroageValueDialog.vue";
import PantryStockNotificationDialog from "@/components/pantry/PantryStockNotificationDialog.vue";
import PantryRecommendView from "@/components/pantry/PantryRecommendView.vue";
import PantryFoodInfoView from "@/components/pantry/PantryFoodInfoView.vue";
import PantryDetailMenuView from "@/components/pantry/PantryDetailMenuView.vue";
import PantryDetailGuideDialog from "@/components/pantry/PantryDetailGuideDialog.vue";
import PantryUtil from "@/utils/pantry-util";
import DateUtil from "@/utils/date-util";
import CommonDesignDialog from "@/components/common/CommonDesignDialog.vue";
import PantryRecommendTitle from "@/components/pantry/PantryRecommendTitle.vue";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import PantryRecommendMainView from "@/components/pantry/PantryRecommendMainView.vue";
import { DATA_URI } from "pixi.js-legacy";
export default defineComponent({
  name: "PantryDetailPage",
  components: {
    PantryDetailView,
    PantryDateValueDialog,
    PantryStroageValueDialog,
    PantryValueDialog,
    PantryStockNotificationDialog,
    PantryRecommendView,
    PantryFoodInfoView,
    PantryDetailMenuView,
    CommonDesignDialog,
    PantryRecommendTitle,
    PantryRecommendMainView,
    PantryDetailGuideDialog
  },
  setup() {
    const ERROR_BUTTON_LABEL = "OK";
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();
    const { closeDialog } = useApiErrorDialog();
    const getApplianceId = () => {
      let applianceId = String(router.currentRoute.value.query.applianceId);
      let result = "";
      if (applianceId == 'undefined') {
        NativeClient.sendDebugLog("getApplianceId empty");
        applianceId = ""
      } else {
        result = decodeURIComponent(applianceId);
      }
      return result;
    };
    const getId = () => {
      const id = Number(router.currentRoute.value.query.id);
      NativeClient.sendDebugLog("getId id=" + id);
      let result = -1;
      if (isNaN(id)) {
        NativeClient.sendDebugLog("getId empty");
      } else {
        result = id;
      }
      return result;
    };
    const getPush = () => {
      const push = Number(router.currentRoute.value.query.push);
      let result = -1;
      if (isNaN(push)) {
        NativeClient.sendDebugLog("getPush empty");
      } else {
        result = push;
      }
      return result;
    };
    const getPlateValue = () => {
      const plateValue = String(router.currentRoute.value.query.plateValue);
      let result = "";
      if (plateValue == null || plateValue == "") {
        NativeClient.sendDebugLog("plateValue empty");
      } else {
        result = plateValue;
      }
      return result;
    }
    const applianceId = getApplianceId();
    const getType = () => {
      const type = String(router.currentRoute.value.query.type);
      NativeClient.sendDebugLog("getType type=" + type);
      let result = "";
      if (type == 'undefined' || type == "") {
        NativeClient.sendDebugLog("getType empty");
        if (applianceId != "") {
          result = PANTRY_FOOD_TYPE.PLATE;
        }
      } else {
        switch (type) {
          case PANTRY_FOOD_TYPE.USER:
          case PANTRY_FOOD_TYPE.PLATE:
          case PANTRY_FOOD_TYPE.FRIDGE:
            result = type;
            break;
          default:
            result = "";
            break;
        }
      }
      return result;
    };
    const id = getId();
    const type = getType();
    const push = getPush();
    const plateValue = getPlateValue();
    const recommendKeyword = ref("");
    const recommendFoodId = ref(DEFALT_FOOD_ID);
    const detailInfo = ref(new PantryDetailInfo());
    const isShowData = ref(false);
    const isShowDataValueDialog = ref(false);
    const isShowStorageValueDialog = ref(false);
    const isShowStockValueDialog = ref(false);
    const isShowStockNotificationDialog = ref(false);
    const isShowMenu = ref(false);
    const dateValueInfo = ref(new DateValueInfo());
    const isShowSelectDialog = ref(false);
    const selectMessage = ref("");
    const isShowCompleteDialog = ref(false);
    const completeMessage = ref("");
    const isShowPlateFoodChange = ref(false);
    const isShowRecommend = ref(false);
    const isShowUpdateButton = ref(false);
    const isShowErrorDialog = ref(false);
    const errorDialogMessage = ref("");
    const isShowFoodInfo = ref(false);
    const isShowPlateUpdateCheckDialog = ref(false);
    const isShowGuideDialog = ref(false);
    const isShowErrorValueDialog = ref(false);
    const cameraApplianceId = ref("");
    NativeClient.sendDebugLog("PantryDetailPage type=" + type + " id=" + id + " applianceId=" + applianceId + " plateValue=" + plateValue);
    NativeClient.showCloseButton(true);
    NativeClient.setTitle(new TitleInfo(false, ""));
    // 表示更新のためのリアクティブ
    const updateStorageKey = ref(0);
    const updateStorage = () => {
      if (updateStorageKey.value >= 100) {
        updateStorageKey.value = 0;
      } else {
        updateStorageKey.value++;
      }
    };
    const updateDateValueDialogKey = ref(0);
    const updateDateValueDialog = () => {
      if (updateDateValueDialogKey.value >= 100) {
        updateDateValueDialogKey.value = 0;
      } else {
        updateDateValueDialogKey.value++;
      }
    };
    const clickMenu = () => {
      isShowMenu.value = true;
    };
    const onShowCamera = async () => {
      // 起動前に連携機器のApplianceIdを取得する
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const applianceId = PantryUtil.getCameraApplianceId();
        NativeClient.sendDebugLog(
          "PantryDetailPage onShowCamera applianceId=" + applianceId
        );
        if (applianceId == null || applianceId == "") {
          return;
        }
        NativeClient.transitionPantryCamera();
      });
    };
    const requnstFavorite = async (foodId: number, status: boolean) => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const webApiList = new Array<any>();
        const payload = new RequestFavoriteFood(foodId);
        const favoriteStatus = !status;
        if (favoriteStatus) {
          webApiList.push(store.dispatch("pantry/addFavoriteFood", payload));
        } else {
          webApiList.push(store.dispatch("pantry/removeFavoriteFood", payload));
        }
        Promise.all(webApiList).then( result => {
          if (detailInfo.value.user != null) {
            detailInfo.value.user.favoriteStatus = favoriteStatus;
          } else if (detailInfo.value.plate != null) {
            detailInfo.value.plate.favoriteStatus = favoriteStatus;
          } else if (detailInfo.value.fridge != null) {
            detailInfo.value.fridge.favoriteStatus = favoriteStatus;
          }
          NativeClient.requestReloadFavoriteFood();
          store.dispatch("common/stopLoading");
        });
      });
    };
    const onClickFavrite = () => {
      let foodId = -1;
      let favoriteStatus = false;
      if (detailInfo.value.user != null) {
        foodId = detailInfo.value.user.ingredientId;
        favoriteStatus = detailInfo.value.user.favoriteStatus;
      } else if (detailInfo.value.plate != null) {
        foodId = detailInfo.value.plate.ingredientId;
        favoriteStatus = detailInfo.value.plate.favoriteStatus;
      } else if (detailInfo.value.fridge != null) {
        foodId = detailInfo.value.fridge.ingredientId;
        favoriteStatus = detailInfo.value.fridge.favoriteStatus;
      }
      if (foodId == -1) {
        return;
      }
      requnstFavorite(foodId, favoriteStatus);
    };
    const favoriteImage = computed(() => {
      let favoriteStatus = false;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.user != null) {
          favoriteStatus = detailInfo.value.user.favoriteStatus;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null) {
          favoriteStatus = detailInfo.value.plate.favoriteStatus;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.fridge != null) {
          favoriteStatus = detailInfo.value.fridge.favoriteStatus;
        }
      }
      NativeClient.sendDebugLog("PantryDetailPage favoriteImage favoriteStatus=" + favoriteStatus);
      return favoriteStatus
        ? require("@/assets/images/icon_pantry_favorite_on.png")
        : require("@/assets/images/icon_pantry_favorite_off.png");
    });
    const onMenuDelete = () => {
      isShowMenu.value = false;
      let name = "";
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.user != null) {
          name = detailInfo.value.user.name;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null) {
          name = detailInfo.value.plate.name;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.fridge != null) {
          name = detailInfo.value.fridge.name;
        }
      }
      selectMessage.value = name + "\nを使い切りましたか?";
      NativeClient.sendDebugLog("PantryDetailPage onMenuDelete selectMessage=" + selectMessage.value);
      isShowSelectDialog.value = true;
    };
    const onMenuClose = () => {
      isShowMenu.value = false;
    };
    const onMenuFoodChange = () => {
      // 食材を変更する
      isShowMenu.value = false;
      isShowPlateFoodChange.value = true;
    };
    const requestRecommendRecipe = async (keyword: string | null, foodId: number | null) => {
      NativeClient.sendDebugLog("PantryDetailPage requestRecommendRecipe keyword=" + keyword + " foodId=" + foodId);
      if (foodId == null) {
        store.dispatch("common/stopLoading");
        return;
      }
      const payload = new RequestRecommendRecipe(keyword, foodId);
      const foodPayload = new RequestFoodRecommendation(foodId);
      await Promise.all([
        store.dispatch("pantry/getRecommendRecipe", payload),
        store.dispatch("pantry/getSearchFood", payload),
        store.dispatch("pantry/getFoodRecommendationList", foodPayload)
      ]).then(result => {
        store.dispatch("common/stopLoading");
      });
    };

    const requestPantryDetailUser = async () => {
      NativeClient.sendDebugLog("PantryDetailPage requestPantryDetailUser id=" + id);
      await Promise.all([
        // store.dispatch("pantry/getFoodConsumeList"),
        store.dispatch("pantry/getPantryDetail", id)
      ]).then(result => {
        const detail = store.getters["pantry/getPantryDetail"];
        NativeClient.sendDebugLog(
          "PantryDetailPage requestPantryDetailUser result=" + JSON.stringify(result)
        );
        if (detail != null) {
          const updateData = new UpdatePantryInfo();
          updateData.setPantryDetail(detail);
          detailInfo.value.setUser(detail, updateData);
          NativeClient.sendDebugLog(
            "PantryDetailPage requestPantryDetailUser detailInfo.value=" +
              JSON.stringify(detailInfo.value)
          );
          recommendKeyword.value = detail.name;
          recommendFoodId.value = detail.ingredientId;
          requestRecommendRecipe(recommendKeyword.value, recommendFoodId.value);
        } else {
          store.dispatch("common/stopLoading");
        }
      });
    };

    const requestPantryDetailPlate = async () => {
      NativeClient.sendDebugLog("PantryDetailPage requestPantryDetailPlate id=" + id);
      const payload = new RequstPantryPlateDetail(id, applianceId);
      const today = DateUtil.getToday();
      const oldDay = DateUtil.subtractionDay(today, 6);
      const weightPayload = new RequstPantryPlateSettingWeight(null, applianceId, oldDay, today);
      await Promise.all([
        // store.dispatch("pantry/getFoodConsumeList"),
        store.dispatch("pantry/getPantryPlateDetail", payload),
      ]).then(result => {
        const detail = store.getters["pantry/getPantryPlateDetail"];
        if (detail && detail.applianceId) {
          payload.applianceId = detail.applianceId;
          weightPayload.applianceId = detail.applianceId;
          if (plateValue != "") {
            if (detail.plate != null) {
              const value = PantryUtil.getPlateValue(detail.plate);
              const valueString = "" + value;
              NativeClient.sendDebugLog(
                "PantryDetailPage requestPantryDetailPlate plateValue=" + plateValue + " valueString=" + valueString
              );
              if (plateValue != valueString) {
                NativeClient.requestUpdatePantryList();
              }
            }
          }
        }
        Promise.all([
          store.dispatch("pantry/getPlateDeviceMode", payload),
          store.dispatch("pantry/getPantryPlateSettingWeight", weightPayload)
        ]).then(result => {
          const mode = store.getters["pantry/getPlateDeviceMode"];
          const weight = store.getters["pantry/getPantryPlateSettingWeight"];
          NativeClient.sendDebugLog(
            "PantryDetailPage requestPantryDetailPlate mode=" + JSON.stringify(mode)
          );
          NativeClient.sendDebugLog(
            "PantryDetailPage requestPantryDetailPlate weight=" + JSON.stringify(weight)
          );
          if (detail != null && mode != null && weight != null) {
            detailInfo.value.setPlate(detail, new UpdatePantryPlateInfo(detail), mode, weight);
            NativeClient.sendDebugLog(
              "PantryDetailPage### requestPantryDetailPlate detailInfo.value=" +
                JSON.stringify(detailInfo.value)
            );
            recommendKeyword.value = detail.name;
            recommendFoodId.value = detail.ingredientId;
            requestRecommendRecipe(recommendKeyword.value, recommendFoodId.value);
          } else {
            store.dispatch("common/stopLoading");
          }
        });
      });
    };

    const requestPantryPlateDeviceMode = async () => {
      NativeClient.sendDebugLog("PantryDetailPage requestPantryPlateDeviceMode");
      if (type != PANTRY_FOOD_TYPE.PLATE || detailInfo.value.plate == null) {
        return;
      }
      const id = detailInfo.value.plate.pantryPlateId;
      const applianceId = detailInfo.value.plate.applianceId;
      const payload = new RequstPantryPlateDetail(id, applianceId);
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([
          store.dispatch("pantry/getPlateDeviceMode", payload),
        ]).then(result => {
          const mode = store.getters["pantry/getPlateDeviceMode"];
          NativeClient.sendDebugLog(
            "PantryDetailPage requestPantryDetailPlate mode=" + JSON.stringify(mode)
          );
          store.dispatch("common/stopLoading");
          if (mode == null || mode.plate == null || mode.plate.internalMode != ALL_TIME_CONNECT_MODE) {
            isShowPlateUpdateCheckDialog.value = true;
            return;
          }
          requestPantryDetailPlate();
        });
      });
    };

    const requestPantryDetailFridge = async () => {
      NativeClient.sendDebugLog("PantryDetailPage requestPantryDetailFridge id=" + id);
      await Promise.all([
        // store.dispatch("pantry/getFoodConsumeList"),
        store.dispatch("pantry/getPantryFridgeDetail", id)
      ]).then(result => {
        const detail = store.getters["pantry/getPantryFridgeDetail"];
        NativeClient.sendDebugLog(
          "PantryDetailPage requestPantryDetailFridge result=" +
            JSON.stringify(result)
        );
        if (detail != null) {
          const updateData = new UpdatePantryFridgeInfo();
          updateData.setPantryFridgeDetail(detail);
          detailInfo.value.setFridge(
            detail,
            updateData
          );
          NativeClient.sendDebugLog(
            "PantryDetailPage requestPantryDetailFridge detailInfo.value=" +
              JSON.stringify(detailInfo.value)
          );
          recommendKeyword.value = detail.name;
          recommendFoodId.value = detail.ingredientId;
          requestRecommendRecipe(recommendKeyword.value, recommendFoodId.value);
        } else {
          store.dispatch("common/stopLoading");
        }
      });
    };

    const requestPantryDetail = async () => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        cameraApplianceId.value = PantryUtil.getCameraApplianceId();
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        NativeClient.sendDebugLog(
          "PantryDetailPage requestPantryDetail type=" + type
        );
        if (type == PANTRY_FOOD_TYPE.USER) {
          requestPantryDetailUser();
        } else if (type == PANTRY_FOOD_TYPE.PLATE) {
          requestPantryDetailPlate();
        } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
          requestPantryDetailFridge();
        } else {
          store.dispatch("common/stopLoading");
        }
      });
    };

    const recommendRecipes = computed(() => {
      const result = store.getters["pantry/getRecommendRecipes"];
      NativeClient.sendDebugLog(
        "PantryDetailPage recommendRecipes result=" + JSON.stringify(result)
      );
      if (result != null && result.recipes != null) {
        const commonRecipe = createRecipeToCommonRecipes(result.recipes);
        return commonRecipe;
      }
      return null;
    });

    const foodInfo = computed(() => {
      const result = store.getters["pantry/getRecipeFoods"];
      NativeClient.sendDebugLog(
        "PantryDetailPage foodInfo result=" + JSON.stringify(result)
      );
      if (result != null && result.foods != null && result.foods.length >= 1) {
        const food = new RecipeFoodItemInfo(result.foods[0]);
        if (food != null && food.item != null) {
          if (food.item.description != null && food.item.description != "") {
            isShowFoodInfo.value = true;
            return food;
          } else if (food.item.shelfLives) {
            for (const shelfLive of food.item.shelfLives) {
              if (shelfLive.tips && shelfLive.tips.description != "") {
                isShowFoodInfo.value = true;
                return food;
              }
            }
          }
        }
      }
      isShowFoodInfo.value = false;
      return null;
    });

    const updatePantryDetail = () => {
      NativeClient.sendDebugLog("PantryDetailPage updatePantryDetail");
      // 画面切り替え通知
      requestPantryDetail();
    };

    // パントリー状態切り替えを登録
    NativeClient.updatePantryDetail(updatePantryDetail);

    const execute = async () => {
      requestPantryDetail();
    };

    const retryGetPantry = () => {
      execute();
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      store.dispatch("pantry/updateRecommendRecipe", null);
      execute();
    });

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onUnmounted(async () => {
      // 画面から離れた場合
    });

    const getDetailApplianceId = () => {
      let applianceId = "";
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null) {
          applianceId = detailInfo.value.plate.applianceId;
        }
      }
      return applianceId;
    };

    const onShowDataSetting = () => {
      isShowData.value = !isShowData.value;
      NativeClient.sendDebugLog(
        "PantryDetailPage isShowData.value=" + isShowData.value
      );
    };

    const setDateValuePurchase = () => {
      let purchaseDate = null;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          purchaseDate = detailInfo.value.updateUser.purchaseDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          purchaseDate = detailInfo.value.updatePlate.purchaseDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          purchaseDate = detailInfo.value.updateFridge.purchaseDate;
        }
      }
      dateValueInfo.value.itemType = DETAIL_ITEM_TYPE.PURCHASE_DATE;
      dateValueInfo.value.date = purchaseDate != null ? purchaseDate : null;
      dateValueInfo.value.defaultDate = DateUtil.getToday();
      dateValueInfo.value.valueType = PLATE_DATE_SETTING.DATE;
      updateDateValueDialog();
    };

    const setDateValueExpiration = () => {
      let expirationDate = null;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          expirationDate = detailInfo.value.updateUser.expirationDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          expirationDate = detailInfo.value.updatePlate.expirationDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          expirationDate = detailInfo.value.updateFridge.expirationDate;
        }
      }
      dateValueInfo.value.itemType = DETAIL_ITEM_TYPE.EXPIRATION_DATE;
      dateValueInfo.value.date =
        expirationDate != null ? expirationDate : null;
      dateValueInfo.value.defaultDate = DateUtil.getToday();
      dateValueInfo.value.valueType = PLATE_DATE_SETTING.DATE;
      updateDateValueDialog();
    };

    const setDateValueNotification = () => {
      let notificationDate = null;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          notificationDate = detailInfo.value.updateUser.notificationDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          notificationDate = detailInfo.value.updatePlate.notificationDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          notificationDate = detailInfo.value.updateFridge.notificationDate;
        }
      }
      dateValueInfo.value.itemType = DETAIL_ITEM_TYPE.NOTIFICATION;
      dateValueInfo.value.date =
        notificationDate != null ? notificationDate : null
      dateValueInfo.value.defaultDate = DateUtil.getToday();
      dateValueInfo.value.valueType = PLATE_DATE_SETTING.NOTIFICATION;
      updateDateValueDialog();
    };

    const onChangeValue = (itemType: number) => {
      NativeClient.sendDebugLog("PantryDetailPage onChangeValue=" + itemType);
      switch (itemType) {
        case DETAIL_ITEM_TYPE.PURCHASE_DATE:
          setDateValuePurchase();
          isShowDataValueDialog.value = true;
          break;
        case DETAIL_ITEM_TYPE.EXPIRATION_DATE:
          setDateValueExpiration();
          isShowDataValueDialog.value = true;
          break;
        case DETAIL_ITEM_TYPE.NOTIFICATION:
          setDateValueNotification();
          isShowDataValueDialog.value = true;
          break;
        case DETAIL_ITEM_TYPE.STOCK_QUANTITY:
          if (type != PANTRY_FOOD_TYPE.PLATE) {
            isShowStockValueDialog.value = true;
          } else {
            if (detailInfo.value.plate) {
              const pantryPlateId = detailInfo.value.plate?.pantryPlateId;
              const applianceId = getDetailApplianceId();
              NativeClient.updatePlateValue(pantryPlateId, applianceId);
              return;
            }
          }
          break;
        case DETAIL_ITEM_TYPE.STORAGE:
          if (type != PANTRY_FOOD_TYPE.FRIDGE) {
            isShowStorageValueDialog.value = true;
            updateStorage();
          }
          break;
        case DETAIL_ITEM_TYPE.STOCK_NOTIFICATION:
          if (type == PANTRY_FOOD_TYPE.PLATE) {
            isShowStockNotificationDialog.value = true;
          }
          break;
      }
    };

    const updateDateValuePurchase = (selectId: number, date: string) => {
      const updateDate = selectId == PLATE_SELECT_DATE_TYPE.NONE ? null : date;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          detailInfo.value.updateUser.purchaseDate = updateDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          detailInfo.value.updatePlate.purchaseDate = updateDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          detailInfo.value.updateFridge.purchaseDate = updateDate;
        }
      }
    };

    const updateDateValueExpiration = (selectId: number, date: string) => {
      const updateDate = selectId == PLATE_SELECT_DATE_TYPE.NONE ? null : date;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          detailInfo.value.updateUser.expirationDate = updateDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          detailInfo.value.updatePlate.expirationDate = updateDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          detailInfo.value.updateFridge.expirationDate = updateDate;
        }
      }
    };

    const updateDateValueNotification = (selectId: number, date: string) => {
      NativeClient.sendDebugLog("updateDateValueNotification selectId=" + selectId + " date=" + date + " type=" + type);
      const updateDate = selectId == PLATE_SELECT_DATE_TYPE.NONE ? null : date;
      NativeClient.sendDebugLog("updateDateValueNotification updateDate=" + updateDate);
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          detailInfo.value.updateUser.notificationDate = updateDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          detailInfo.value.updatePlate.notificationDate = updateDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          detailInfo.value.updateFridge.notificationDate = updateDate;
        }
      }
    };

    const onDateValueDialogSetting = (
      itemType: number,
      selectId: number,
      date: string,
      original: string
    ) => {
      const todayString = DateUtil.getToday();
      const todayMs = DateUtil.getDateMs(todayString);
      const futureDateString = DateUtil.addDay(todayString, 1);
      const futureDateMs = DateUtil.getDateMs(futureDateString);
      const updateDateMs = selectId == PLATE_SELECT_DATE_TYPE.NONE ? null : DateUtil.getDateMs(date);
      NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting date=" + date + " updateDateMs=" + updateDateMs);
      NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting todayString=" + todayString +" todayMs=" + todayMs);
      NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting futureDateString= " + futureDateString + " futureDateMs=" + futureDateMs);
      NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting original= " + original);
      isShowDataValueDialog.value = false;
      switch (itemType) {
        case DETAIL_ITEM_TYPE.PURCHASE_DATE:
          if (type == PANTRY_FOOD_TYPE.FRIDGE && updateDateMs == null) {
            NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting error PURCHASE_DATE updateDateMs null");
            isShowErrorValueDialog.value = true;
            return;
          }
          if (updateDateMs != null && updateDateMs >= futureDateMs) {
            NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting error PURCHASE_DATE");
            errorDialogMessage.value = "入庫日を本日より未来に設定することができません。";
            isShowErrorDialog.value = true;
            dateValueInfo.value.date = null;
            return;
          }
          updateDateValuePurchase(selectId, date);
          isShowUpdateButton.value = true;
          break;
        case DETAIL_ITEM_TYPE.EXPIRATION_DATE:
          if (updateDateMs != null && updateDateMs < todayMs) {
            NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting error EXPIRATION_DATE");
            errorDialogMessage.value = "利用期限目安日を本日より過去に設定することができません。";
            isShowErrorDialog.value = true;
            dateValueInfo.value.date = null;
            return;
          }
          updateDateValueExpiration(selectId, date);
          isShowUpdateButton.value = true;
          break;
        case DETAIL_ITEM_TYPE.NOTIFICATION:
          if (updateDateMs != null && updateDateMs < todayMs) {
            NativeClient.sendDebugLog("PantryDetailPage onDateValueDialogSetting error NOTIFICATION");
            errorDialogMessage.value = "使い忘れ通知日を本日より過去に設定することができません。";
            isShowErrorDialog.value = true;
            dateValueInfo.value.date = null;
            return;
          }
          updateDateValueNotification(selectId, date);
          isShowUpdateButton.value = true;
          break;
      }
    };

    const onDateValueDialogClose = () => {
      isShowDataValueDialog.value = false;
    };

    const onStockValueDialogSetting = (value: number) => {
      isShowStockValueDialog.value = false;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          detailInfo.value.updateUser.stockQuantity = value;
          isShowUpdateButton.value = true;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          detailInfo.value.updateFridge.stockQuantity = value;
          isShowUpdateButton.value = true;
        }
      }
    };

    const onStockValueDialogClose = () => {
      isShowStockValueDialog.value = false;
    };

    const onStorageValueDialogSetting = (id: number) => {
      const storage = PantryUtil.getStorageName(id);
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          if (storage != PANTRY_STORAGE_TYPE.ALL) {
            detailInfo.value.updateUser.storageType = storage;
          } else {
            detailInfo.value.updateUser.storageType = null;
          }
          isShowUpdateButton.value = true;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          if (storage != PANTRY_STORAGE_TYPE.ALL) {
            detailInfo.value.updatePlate.storageType = storage;
          } else {
            detailInfo.value.updatePlate.storageType = null;
          }
          isShowUpdateButton.value = true;
        }
      }
      isShowStorageValueDialog.value = false;
    };

    const onStorageValueDialogClose = () => {
      isShowStorageValueDialog.value = false;
    };

    const onStockNotificationDialogSetting = (timing: number, time: number | null, stock: number) => {
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null && detailInfo.value.updatePlate.plate != null && detailInfo.value.updatePlate.plate.remaining != null) {
          detailInfo.value.updatePlate.plate.thresholdCount = stock;
          detailInfo.value.updatePlate.plate.remaining.timing = timing;
          detailInfo.value.updatePlate.plate.remaining.time = time;
          isShowUpdateButton.value = true;
        }
      }
      isShowStockNotificationDialog.value = false;
    };

    const onStockNotificationDialogClose = () => {
      isShowStockNotificationDialog.value = false;
    };

    const getStockValue = () => {
      let result = null;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          result = detailInfo.value.updateUser.stockQuantity;
          result = PantryUtil.getStockQuantity(result);
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          result = detailInfo.value.updateFridge.stockQuantity;
          result = PantryUtil.getStockQuantity(result);
        }
      }
      return result;
    };

    const getStorageValue = () => {
      let storageType = null;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          storageType = detailInfo.value.updateUser.storageType;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          storageType = detailInfo.value.updatePlate.storageType;
        }
      }
      const result = PantryUtil.getStorageId(storageType);
      return result;
    };
    const getUpdatePlateData = () => {
      let result = null;
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          result = detailInfo.value.updatePlate.plate;
        }
      }
      return result;
    };
    const getDisplayFormat = () => {
      let result = PLATE_DISPLAY_FORMAT.GAUGE;
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null && detailInfo.value.plate.plate != null && detailInfo.value.plate.plate.unit != null) {
          result = detailInfo.value.plate.plate.unit.displayFormat;
        }
      }
      return result;
    };
    const getNetworkTiming = () => {
      let result = NETWORK_TIMING.NORMAL;
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null && detailInfo.value.plate.plate != null && detailInfo.value.plate.plate.network != null) {
          result = detailInfo.value.plate.plate.network.timing;
        }
      }
      return result;
    };
    const getStockNotificationMaxStockValue = () => {
      let result = 20;
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null && detailInfo.value.plate.plate != null && detailInfo.value.plate.plate.unit != null) {
          result = detailInfo.value.plate.plate.unit.fullWeight / detailInfo.value.plate.plate.unit.unitWeight;
          result = Math.floor(result);
        }
      }
      return result;
    };
    const getStockNotificationTime = () => {
      let result = "0:00";
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null 
        && detailInfo.value.updatePlate.plate != null
        && detailInfo.value.updatePlate.plate.remaining != null
        && detailInfo.value.updatePlate.plate.remaining.time != null) {
          result = detailInfo.value.updatePlate.plate.remaining.time + ":00";
        }
      }
      NativeClient.sendDebugLog("PantryDetailPage getStockNotificationTime result=" + result);
      return result;
    };
    const getStockNotificationStock = () => {
      let result = "";
      NativeClient.sendDebugLog("PantryDetailPage### getStockNotificationStock type=" + type);
      if (type == PANTRY_FOOD_TYPE.PLATE) {
        NativeClient.sendDebugLog("PantryDetailPage### getStockNotificationStock plate=" + JSON.stringify(detailInfo.value.plate));
        NativeClient.sendDebugLog("PantryDetailPage### getStockNotificationStock updatePlate=" + JSON.stringify(detailInfo.value.updatePlate));
        if (detailInfo.value.plate != null && detailInfo.value.plate.plate != null && detailInfo.value.plate.plate.unit != null) {
          const format = detailInfo.value.plate.plate.unit.displayFormat;
          if (detailInfo.value.updatePlate != null 
          && detailInfo.value.updatePlate.plate != null) {
            const stock = detailInfo.value.updatePlate.plate.thresholdCount;
            if (stock != -1) {
              result = "" + stock;
              result += (format == PLATE_DISPLAY_FORMAT.GAUGE) ? "%" : "個" 
            }
          }
        }
      }
      NativeClient.sendDebugLog("PantryDetailPage getStockNotificationStock result=" + result);
      return result;
    };

    const requestDelete = async (foodStatus: number) => {
      completeMessage.value = foodStatus == PLATE_DELETE_FOOD_STATUS.THREW_AWAY ? "食材が廃棄されました" : "食材が消費されました";
      NativeClient.sendDebugLog("PantryDetailPage complteMessage=" + completeMessage.value);
      store.dispatch("common/startLoading");
      const payload = new DeletePantryInfo();
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.user != null) {
            payload.pantryList.push(new DetetePantryItem(detailInfo.value.user.pantryId, foodStatus));
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null) {
          payload.pantryPlateList.push(new DetetePantryPlateItem(detailInfo.value.plate.pantryPlateId, foodStatus));
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.fridge != null) {
          payload.pantryFridgeList.push(new DetetePantryFridgeItem(detailInfo.value.fridge.pantryFridgeId, foodStatus));
        }
      }
      NativeClient.sendDebugLog("PantryDetailPage requestDeletePantry payload=" + JSON.stringify(payload));
      const apiBaseParams = store.getters["common/getApiBaseParams"];
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([
          store.dispatch("pantry/deletePantry", payload),
        ]).then(result => {
          isShowCompleteDialog.value = true;
          NativeClient.requestUpdatePantryList();
          store.dispatch("common/stopLoading");
        });
      });
    };
    const requestShoppingIngredients = async (shoppingFoods: RequestShoppingFoods) => {
      store.dispatch("common/startLoading");
      const apiBaseParams = store.getters["common/getApiBaseParams"];
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([store.dispatch("pantry/registerShoppingFoods", shoppingFoods)]).then(
          result => {
            store.dispatch("common/stopLoading");
          }
        );
      });
    };
    const onClickSelectNegative = () => {
      isShowSelectDialog.value = false;
      requestDelete(PLATE_DELETE_FOOD_STATUS.THREW_AWAY);
    };
    const onClickSelectPositive = () => {
      isShowSelectDialog.value = false;
      requestDelete(PLATE_DELETE_FOOD_STATUS.USED);
    };
    const onClickSelectClose = () => {
      isShowSelectDialog.value = false;
    }
    const onClickComplete = () => {
      isShowCompleteDialog.value = false;
      // モーダル表示の場合はNativeで画面を終了する
      NativeClient.pageClose();
    };
    const clickSeeMore = (type: string) => {
      NativeClient.sendDebugLog("PantryDetailPage clickSeeMore type=" + type);
      switch (type) {
        case PANTRY_RECIPE_TYPE.RECOMMEND:
          NativeClient.sendDebugLog("PantryDetailPage clickSeeMore keyword=" + recommendKeyword.value + " foodId=" + recommendFoodId.value);
          isShowRecommend.value = true;
          NativeClient.showCloseButton(false);
          break;
      }
    };
    const onClickShopList = () => {
      NativeClient.sendDebugLog("PantryDetailPage onClickShopList keyword=" + recommendKeyword.value + " foodId=" + recommendFoodId.value);
      const shoppingFood = new RequestShoppingFood(recommendFoodId.value, recommendKeyword.value);
      const shoppingFoods = new RequestShoppingFoods();
      shoppingFoods.foods.push(shoppingFood);
      requestShoppingIngredients(shoppingFoods);
    };
    const onClickPlateFoodChangeNegative = () => {
      isShowPlateFoodChange.value = false;
      const applianceId = getDetailApplianceId();
      if (applianceId == "") {
        NativeClient.sendDebugLog("PantryDetailPage onClickPlateFoodChangeNegative applianceId empty");
        return;
      }
      NativeClient.changePlateFood(applianceId);
    };
    const onClickPlateFoodChangePositive = () => {
      isShowPlateFoodChange.value = false;
      const applianceId = getDetailApplianceId();
      if (applianceId == "") {
        NativeClient.sendDebugLog("PantryDetailPage onClickPlateFoodChangePositive applianceId empty");
        return;
      }
      NativeClient.changePlateFoodReset(applianceId);
    };
    const onUpdatePlate = () => {
      NativeClient.sendDebugLog("PantryDetailPage onUpdatePlate");
      requestPantryPlateDeviceMode();
    };
    const onCloseRecommend = () => {
      isShowRecommend.value = false;
      NativeClient.showCloseButton(true);
    };
    const checkUpdate = (purchaseDate: string | null,
      expirationDate: string | null,
      notificationDate: string | null) => {
      const purchaseMs = purchaseDate != null ? DateUtil.getDateMs(purchaseDate) : null;
      const expirationMs = expirationDate != null ? DateUtil.getDateMs(expirationDate) : null;
      const notificationMs = notificationDate != null ? DateUtil.getDateMs(notificationDate) : null;
      NativeClient.sendDebugLog("PantryDetailPage checkUpdate purchaseDate=" + purchaseDate + " expirationDate=" + expirationDate + " notificationDate=" + notificationDate);
      if (purchaseMs != null && expirationMs != null && purchaseMs > expirationMs) {
        return "利用期限目安日を入庫日より過去に設定することはできません。";
      }
      if (purchaseMs != null && notificationMs != null && purchaseMs > notificationMs) {
        return "使い忘れ通知日を入庫日より過去に設定することはできません。";
      }
      if (expirationMs != null && notificationMs != null && expirationMs < notificationMs) {
        return "使い忘れ通知日を利用期限目安日より未来に設定することはできません。";
      }
      return "";
    };
    const requestUpdateUserValue = () => {
      if (detailInfo.value.updateUser == null || detailInfo.value.user == null) {
        store.dispatch("common/stopLoading");
        return;
      }
      const payload = new RequestUpdateFoodData(detailInfo.value.user.pantryId, detailInfo.value.updateUser);
      Promise.all([
        store.dispatch("pantry/updatePantry", payload),
      ]).then(result => {
        NativeClient.requestUpdatePantryList();
        isShowUpdateButton.value = false;
        store.dispatch("common/stopLoading");
      });
    };
    const requestUpdatePlateValue = () => {
      if (detailInfo.value.updatePlate == null || detailInfo.value.plate == null) {
        store.dispatch("common/stopLoading");
        return;
      }
      const payload = new RequestUpdatePlateFoodData(detailInfo.value.plate.pantryPlateId, detailInfo.value.updatePlate);
      Promise.all([
        store.dispatch("pantry/updatePlatePantry", payload),
      ]).then(result => {
        NativeClient.requestUpdatePantryList();
        isShowUpdateButton.value = false;
        store.dispatch("common/stopLoading");
      });
    };
    const requestUpdateFridgeValue = () => {
      if (detailInfo.value.updateFridge == null || detailInfo.value.fridge == null) {
        store.dispatch("common/stopLoading");
        return;
      }
      const payload = new RequestUpdateFridgeFoodData(detailInfo.value.fridge.pantryFridgeId, detailInfo.value.updateFridge);
      Promise.all([
        store.dispatch("pantry/updateFridgePantry", payload),
      ]).then(result => {
        NativeClient.requestUpdatePantryList();
        isShowUpdateButton.value = false;
        store.dispatch("common/stopLoading");
      });
    };
    const requestValue = async () => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        NativeClient.sendDebugLog(
          "PantryDetailPage requestPantryDetail type=" + type
        );
        if (type == PANTRY_FOOD_TYPE.USER) {
          requestUpdateUserValue();
        } else if (type == PANTRY_FOOD_TYPE.PLATE) {
          requestUpdatePlateValue();
        } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
          requestUpdateFridgeValue();
        } else {
          store.dispatch("common/stopLoading");
        }
      });
    }
    const onUpdateValue = () => {
      NativeClient.sendDebugLog("PantryDetailPage onUpdateValue");
      let purchaseDate = null;
      let notificationDate = null;
      let expirationDate = null;
      let stockQuantity = null;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.updateUser != null) {
          purchaseDate = detailInfo.value.updateUser.purchaseDate;
          expirationDate = detailInfo.value.updateUser.expirationDate;
          notificationDate = detailInfo.value.updateUser.notificationDate;
          stockQuantity = detailInfo.value.updateUser.stockQuantity;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.updatePlate != null) {
          purchaseDate = detailInfo.value.updatePlate.purchaseDate;
          expirationDate = detailInfo.value.updatePlate.expirationDate;
          notificationDate = detailInfo.value.updatePlate.notificationDate;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.updateFridge != null) {
          purchaseDate = detailInfo.value.updateFridge.purchaseDate;
          expirationDate = detailInfo.value.updateFridge.expirationDate;
          notificationDate = detailInfo.value.updateFridge.notificationDate;
          stockQuantity = detailInfo.value.updateFridge.stockQuantity;
        }
      }
      NativeClient.sendDebugLog("PantryDetailPage onUpdateValue stockQuantity=" + stockQuantity);
      if (stockQuantity != null && stockQuantity == 0 && type != PANTRY_FOOD_TYPE.PLATE) {
        // プレート食材以外の場合、残量0%であれば削除確認ダイアログを表示する。
        onMenuDelete();
        return;
      }
      const errorMessage = checkUpdate(purchaseDate, expirationDate, notificationDate);
      NativeClient.sendDebugLog("PantryDetailPage onUpdateValue errorMessage=" + errorMessage);
      if (errorMessage != "") {
        errorDialogMessage.value = errorMessage;
        isShowErrorDialog.value = true;
        return;
      }
      requestValue();
    };
    const onClickError = () => {
      isShowErrorDialog.value = false;
    };
    const onClickErrorValue = () => {
      isShowErrorValueDialog.value = false;
      isShowDataValueDialog.value = true;
    }
    const onClickPlateUpdateCheckDialog = () => {
      isShowPlateUpdateCheckDialog.value = false;
    };
    const isShowRecommendList = () => {
      return (recommendRecipes.value && recommendRecipes.value.length >= 1);
    }
    const onSelectRecipe = (id: number, type: string) => {
      // Native側にレシピ詳細画面に遷移指示を出す
      NativeClient.sendDebugLog(
        "PantryDetailPage selectRecipe id=" + id + " type=" + type
      );
      NativeClient.transitionReceipDetail(id, type);
    };
    const onShowGuide = () => {
      NativeClient.sendDebugLog("PantryDetailPage onShowGuide");
      isShowGuideDialog.value = true;
    };
    const onCloseGuideDialog = () => {
      isShowGuideDialog.value = false;
    };
    const isShowFavrite = () => {
      let foodId = null;
      if (type == PANTRY_FOOD_TYPE.USER) {
        if (detailInfo.value.user != null) {
          foodId = detailInfo.value.user.ingredientId;
        }
      } else if (type == PANTRY_FOOD_TYPE.PLATE) {
        if (detailInfo.value.plate != null) {
          foodId = detailInfo.value.plate.ingredientId;
        }
      } else if (type == PANTRY_FOOD_TYPE.FRIDGE) {
        if (detailInfo.value.fridge != null) {
          foodId = detailInfo.value.fridge.ingredientId;
        }
      }
      return foodId != null;
    }
    const isShowCamera = computed(() => {
      return cameraApplianceId.value != "";
    });
    const closeError = () => {
      closeDialog();
      NativeClient.showCameraCloseButton(true);
    };
    return {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      retryGetPantry,
      type,
      detailInfo,
      isShowData,
      onShowDataSetting,
      onChangeValue,
      isShowDataValueDialog,
      onDateValueDialogSetting,
      onDateValueDialogClose,
      isShowStorageValueDialog,
      onStorageValueDialogSetting,
      onStorageValueDialogClose,
      isShowStockValueDialog,
      onStockValueDialogSetting,
      onStockValueDialogClose,
      getStockValue,
      getStorageValue,
      dateValueInfo,
      onStockNotificationDialogSetting,
      onStockNotificationDialogClose,
      isShowStockNotificationDialog,
      getNetworkTiming,
      getDisplayFormat,
      getUpdatePlateData,
      getStockNotificationMaxStockValue,
      getStockNotificationTime,
      getStockNotificationStock,
      recommendRecipes,
      foodInfo,
      clickMenu,
      isShowMenu,
      onMenuDelete,
      onMenuClose,
      selectMessage,
      onClickSelectNegative,
      onClickSelectPositive,
      isShowSelectDialog,
      isShowCompleteDialog,
      completeMessage,
      onClickComplete,
      onShowCamera,
      onClickFavrite,
      favoriteImage,
      PANTRY_FOOD_TYPE,
      PANTRY_RECIPE_TYPE,
      clickSeeMore,
      onMenuFoodChange,
      onClickShopList,
      push,
      isShowPlateFoodChange,
      onClickPlateFoodChangeNegative,
      onClickPlateFoodChangePositive,
      onUpdatePlate,
      isShowRecommend,
      onCloseRecommend,
      isShowUpdateButton,
      onUpdateValue,
      closeDialog,
      isShowErrorDialog,
      onClickError,
      errorDialogMessage,
      isShowFoodInfo,
      onClickPlateUpdateCheckDialog,
      isShowPlateUpdateCheckDialog,
      isShowRecommendList,
      onSelectRecipe,
      updateStorageKey,
      onClickSelectClose,
      onShowGuide,
      onCloseGuideDialog,
      isShowGuideDialog,
      updateDateValueDialogKey,
      isShowFavrite,
      onClickErrorValue,
      isShowErrorValueDialog,
      isShowCamera,
      closeError,
      ERROR_BUTTON_LABEL
    }
  }
});
